<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->
<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
    <data-table id="drivers-grid"
        headerTitle="LDAP Users"
        [items]="items"
         [autoReload]="false"
          [header]="true"
         [sortBy]="'lastName'"
          [sortAsc]="true"
          [selectOnRowClick]="false"
         (reload)="reloadItems($event)"
          (cellClick)="EditClick($event)"

        [rowTooltip]="rowTooltip"
         [expandableRows]="true"
        [editDeleteButtonColumn]="false"
         [indexColumn] ="false"
          [selectColumn]="false"
          [substituteRows]="false"
                [pagination]="false"
        >
      <ng-template #dataTableExpand let-item="item">
        <div style="padding: 5px; color: gray; font-size: 0.85em;"> Company : {{item.company}}</div>
        <div style="padding:5px; color: gray; font-size: 0.85em;" *ngIf="item.employeeTypeId==1">GM Department : {{item.department}}</div>
      </ng-template>
        <data-table-column
          [property]="'identificationId'"
          [header]="'GMIN'"
          width="100px"
         [visible]="true">
        </data-table-column>
        <data-table-column
            [property]="'firstName'"
            [header]="'First Name'"
            [resizable]="true"
             width="180px">
        </data-table-column>
      <data-table-column
        [property]="'middleName'"
        [header]="'M'"
        [resizable]="false"
        width="50px">
      </data-table-column>
      <data-table-column
        [property]="'lastName'"
        [header]="'Last Name'"
        [resizable]="true"
        width="220px">
      </data-table-column>
      <data-table-column
        property="preferredName"
        header="Preferred"
        width="150px">
      </data-table-column>
      <data-table-column
        [property]="'email'"
        [header]="'Email'"
        [resizable]="true">
      </data-table-column>

        <data-table-column
            property="phoneNumber"
            header="Phone#"
            width="150px">
        </data-table-column>
      <data-table-column
        header="Actions"
        width="105px">
        <ng-template #dataTableHeader let-item="item">
          <i style="color:darkred">Actions</i>
        </ng-template>
        <ng-template #dataTableCell let-item="item">
          <button (click)="AddClick(item)" class="btn btn-secondary EditButton" style="padding: 2px 10px;"><i class="fa fa-plus"></i> Add</button>
          <div *ngIf="!needFullPage" class="input-group">
            <input type="checkbox" id="{{'isCertifiedDriver'+ item.identificationId}}" name="isCertifiedDriver" value="Certified Driver?">
            <span style="font-size: 0.7em" class="input-group-addon">Add As Driver?</span>
          </div>
        </ng-template>
      </data-table-column>
    </data-table>

<br/>
<data-table id="drivers-existing-grid"
            headerTitle="{{secondTableTitle}}"
            [items]="exitingItems"
            [autoReload]="false"
            [header]="true"
            [sortBy]="'lastName'"
            [sortAsc]="true"
            [selectOnRowClick]="false"
            (reload)="reloadExistingItems($event)"
            (cellClick)="EditClick($event)"

            [rowTooltip]="rowTooltip"
            [expandableRows]="false"
            [editDeleteButtonColumn]="false"
            [indexColumn] ="false"
            [selectColumn]="false"
            [substituteRows]="false"
            [pagination]="false"

>
  <ng-template #dataTableExpand let-item="item">
    <div [textContent]="item.comments" style="padding: 5px; color: gray; font-size: 0.85em;"></div>
  </ng-template>
  <data-table-column
    [property]="'identificationId'"
    [header]="'GMIN'"
    width="110px"
    [visible]="true">
  </data-table-column>
  <data-table-column
    [property]="'firstName'"
    [header]="'First Name'"
    [resizable]="true"
    width="200px">
  </data-table-column>
  <data-table-column
    [property]="'middleName'"
    [header]="'M'"
    [resizable]="false"
    width="50px">
  </data-table-column>
  <data-table-column
    [property]="'lastName'"
    [header]="'Last Name'"
    [resizable]="true"
    width="220px">
  </data-table-column>
  <data-table-column
    property="preferredName"
    header="Preferred"
    width="150px">
  </data-table-column>
  <data-table-column
    [property]="'email'"
    [header]="'Email'"
    [resizable]="true">
  </data-table-column>
  <data-table-column
    property="phoneNumber"
    header="Phone#"
    width="150px">
  </data-table-column>
  <data-table-column
    header="Actions">
    <ng-template #dataTableHeader let-item="item">
      <button *ngIf="needFullPage" onclick="window.location.href='#/driverDetail'" class="btn btn-primary" style="padding: 2px 10px;"><i class="fa fa-plus-circle"></i> Create New</button>
      <button *ngIf="!needFullPage" (click)="OpenModal()" class="btn btn-primary" style="padding: 2px 10px;"><i class="fa fa-plus-circle"></i> Create New</button>
    </ng-template>
    <ng-template #dataTableCell let-item="item">
      <button *ngIf="needFullPage" (click)="EditClick(item)" class="btn btn-secondary" style="padding: 2px 10px;"><i class="fa fa-edit"></i> Edit</button>
      <button *ngIf="!needFullPage" (click)="SelectPerson(item)" class="btn btn-secondary" style="padding: 2px 10px;"><i class="fa fa-check"></i> Select</button>

    </ng-template>
  </data-table-column>
</data-table>

